import { render, staticRenderFns } from "./lainojenyhdistely.vue?vue&type=template&id=6a1260e6&"
import script from "./lainojenyhdistely.vue?vue&type=script&lang=js&"
export * from "./lainojenyhdistely.vue?vue&type=script&lang=js&"
import style0 from "./lainojenyhdistely.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports